import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../../components/SEO';
import ContactComponent from '../../components/Contact/Contact';
import './Contact.css';

const Contact = () => {
  const { i18n } = useTranslation();
  const isFr = i18n.language === 'fr';

  return (
    <div className="contact-page">
      <SEO
        title={isFr ? 'Contact - Parlons de Votre Projet' : 'Contact - Let\'s Talk About Your Project'}
        description={isFr
          ? 'Contactez OPTEAM Services pour discuter de vos projets d\'automatisation RPA, IA et Low-Code. Nos experts vous accompagnent.'
          : 'Contact OPTEAM Services to discuss your RPA, AI and Low-Code automation projects. Our experts are here to help.'
        }
        canonical="/contact"
      />
      <ContactComponent />
    </div>
  );
};

export default Contact;